import type {LinksFunction} from "react-router";

export const links: LinksFunction = () => [
    {
        rel: "icon",
        href: "/favicon.ico",
        type: "image/x-icon",
    },
    {rel: "preconnect", href: "https://fonts.googleapis.com"},
    {
        rel: "preconnect",
        href: "https://fonts.gstatic.com",
        crossOrigin: "anonymous",
    },
    {
        rel: "stylesheet",
        href: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@300;400;500;600;700&family=IBM+Plex+Sans+Devanagari:wght@500;600;700&family=Inter:wght@400;500;600&display=swap",
    },
];
